import ChatConnectFooter from './ChatConnectFooter';

export default ChatConnectFooter;
